import UxIcon, { IconIdType } from "./UxIcon"
import { Box, IconButton } from "@mui/material"

const DialogHeader = ({backgroundColor, handleClose, iconId, label}: {backgroundColor: string, handleClose: () => void, iconId?: string, label: string}) => {
  return (
    <Box sx={{
      alignItems: "center",
      backgroundColor: backgroundColor,
      color: "white",
      display: "grid",
      gridGap: "15px",
      gridTemplateColumns: "auto min-content",
      padding: "10px 20px"
    }}>
      <Box sx={{
        display: "grid",
        fontSize: "18px",
        fontWeight: 500,
        gridGap: "15px",
        gridTemplateColumns: iconId ? "min-content auto" : "auto",
        alignItems: "center"
      }}>
        {iconId !== undefined &&
          <UxIcon id={iconId as IconIdType} />
        }
        {label}
      </Box>
      <IconButton aria-label="settings" onClick={handleClose}>
        <UxIcon id="close" sx={{color: "white"}} />
      </IconButton>
    </Box>
  )
}

export default DialogHeader